import {
  InputWrapper,
  StyledInput,
} from '@/components/Approval/LeftContainer/PeopleFilter/styles';
import SvgImage from '@/components/Module/SvgImage';
import { KeyboardEvent, ReactNode, useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type P = {
  value: string;
  placeholder?: string;
  handleKeyDown?(event: KeyboardEvent<HTMLInputElement>): void;
  onBlur?(): void;
  children?: ReactNode;
  /** 팝오버 안에서 패널 폭을 꽉 채우는 검색바(테두리 없이 하단 구분선만) */
  bleed?: boolean;
};

const Input = ({
  value,
  placeholder = '이름, 닉네임, ID로 검색',
  handleKeyDown,
  onBlur,
  children,
  bleed,
}: P) => {
  const { register, watch, resetField, setFocus } = useFormContext(); // retrieve all hook methods

  const notEmpty = watch(value);
  const { t } = useTranslation();

  const [isFocus, setIsFocus] = useState<boolean | null>(null);

  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setIsFocus(false); // div 외부 클릭 시 포커스를 해제
      onBlur?.();
    } else {
      setIsFocus(true);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <InputWrapper ref={ref} onClick={() => setFocus(value)}>
      {/* 입력창 + 아이콘만 감싸는 행 — 아래 인라인 검색결과가 아이콘 위치를 밀지 않도록 분리 */}
      <div style={{ position: 'relative', width: '100%' }}>
        <StyledInput
          placeholder={t(placeholder)}
          {...register(value)}
          autoComplete={'off'}
          onKeyDown={handleKeyDown}
          style={
            bleed
              ? {
                  borderRadius: 0,
                  border: 'none',
                  borderBottom: '1px solid var(--dk-line, #e7e9ec)',
                  padding: '12px 16px',
                }
              : undefined
          }
        />
        <div
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {/* 검색어가 있으면 X + 돋보기 둘 다 (메인 검색필드와 동일) */}
          {notEmpty && (
            <button style={{ padding: '0' }} onClick={() => resetField(value)}>
              <SvgImage name={'delete'} />
            </button>
          )}
          <SvgImage name={'search'} />
        </div>
      </div>
      {isFocus && children}
    </InputWrapper>
  );
};

export default Input;
